<template>
  <v-row justify="center">
    <v-dialog v-model="active" persistent max-width="400">
      <v-card class="px-3 pt-5 pb-8" style="background: #FBFBFB">
        <div class="my-4">
          <h2 class="text-center mt-1" style="font-weight:600; font-size:18px">
            親愛的教師，場次證照逐一產製中
          </h2>
          <h2 class="text-center mt-1" style="font-weight:600; font-size:18px">
            請耐心等待...
          </h2>
        </div>
        <v-img :src="images.loadingVideo" contain height="140" alt="Loading Video"></v-img>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  export default {
    name:'LoadingVideo',
    props:['onSave'],
    data () {
      return {
        active: false,
        onSaveEn: false,
        images:{
          loadingVideo: require('@/assets/image/loadingVideo.gif')
        },
      }
    },
    methods:{
      open(){
        this.active = true
      },
      close(){
        this.active = false
      },
      save(){
        this.onSave()
        this.close()
      }
    }
  }
</script>